import { ROUTER } from '@core/constants/router.constants';
import { PrivateRoute } from '@router/private-route';
import { RouteObject } from 'react-router-dom';

import { ChefsAssistantLayout } from './chefs-assistant.layout';
import { MainChefsAssistantPage } from './pages';
import { CashBookPage } from './pages/cash-book';
import { ProductPage, PurchaseOrderPage } from './pages/stock';
import { TechnicalSheetPage } from './pages/technical-sheets';

export const chefsAssistantRouter: RouteObject = {
  path: ROUTER.CHEFS_ASSISTANT.INDEX,
  Component: ChefsAssistantLayout,
  children: [
    { index: true, element: <PrivateRoute element={<MainChefsAssistantPage />} /> },
    { path: ROUTER.CHEFS_ASSISTANT.TECHNICAL_SHEETS, element: <PrivateRoute element={<TechnicalSheetPage />} /> },
    { path: ROUTER.CHEFS_ASSISTANT.STOCK.PRODUCTS, element: <PrivateRoute element={<ProductPage />} /> },
    { path: ROUTER.CHEFS_ASSISTANT.STOCK.PURCHASE_ORDER, element: <PrivateRoute element={<PurchaseOrderPage />} /> },
    { path: ROUTER.CHEFS_ASSISTANT.CASH_BOOK, element: <PrivateRoute element={<CashBookPage />} /> },
  ],
};
